module.exports = __webpack_public_path__ + "static/media/icon_chevron_left.1c0d963d.svg";